import dayjs from "dayjs";
import { useSnackbar } from "notistack";

import { useCallback } from "react";

import { FlightWayEnum } from "@/constants";
import { MAX_MEGA_FLIGHT_RANGE } from "@/constants/membership";
import usePlatform from "@/hooks/usePlatform";
import { SearchConditionType } from "@/hooks/useSearchCondition";

const useCheckSearchCondition = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = usePlatform();

  const checkSearchCondition = useCallback(
    (data: SearchConditionType) => {
      let errMsg = "";
      const { fromLocation, toLocation, flightWay, range, programs } = data;
      // Get all iata from fromLocation and toLocation
      const fromIata = fromLocation.map((location) => location.iata);
      const toIata = toLocation.map((location) => location.iata);

      if (fromIata.includes(undefined) || toIata.includes(undefined)) {
        errMsg = "Invalid airport selected";
      } else if (!fromLocation.length) {
        errMsg = "Please select departure airport";
      } else if (!toLocation.length) {
        errMsg = "Please select arrival airport";
      } else if (!programs.length) {
        errMsg = "Please select programs";
      } else if (flightWay === FlightWayEnum.OneWay) {
        const rangeMaxDays = MAX_MEGA_FLIGHT_RANGE;

        if (range) {
          if (!data.oneWayRangeStartDate || !data.oneWayRangeEndDate) {
            errMsg = "Please select departure date";
          } else if (
            dayjs(data.oneWayRangeEndDate).diff(data.oneWayRangeStartDate, "day") >= rangeMaxDays
          ) {
            errMsg = `Please select a date range less than ${rangeMaxDays} days`;
          }
        } else {
          if (!data.oneWayDate) {
            errMsg = "Please select departure date";
          }
        }
      } else if (flightWay === FlightWayEnum.RoundTrip) {
        const rangeMaxDays = MAX_MEGA_FLIGHT_RANGE;

        if (range) {
          if (!data.departureRangeStartDate || !data.departureRangeEndDate) {
            errMsg = "Please select departure date range";
          } else if (
            (!data.returnRangeStartDate || !data.returnRangeEndDate) &&
            !data.roundTripReturnDate
          ) {
            console.log("data.roundTripDepartureDate: ", data.roundTripReturnDate);
            errMsg = "Please select return date range";
          } else if (
            dayjs(data.departureRangeEndDate).diff(data.departureRangeStartDate, "day") >=
            rangeMaxDays
          ) {
            errMsg = `Please select a date range less than ${rangeMaxDays} days`;
          } else if (
            dayjs(data.returnRangeEndDate).diff(data.returnRangeStartDate, "day") >= rangeMaxDays
          ) {
            errMsg = `Please select a date range less than ${rangeMaxDays} days`;
          }
        } else {
          if (!data.roundTripDepartureDate) {
            errMsg = "Please select departure date";
          } else if (!data.roundTripReturnDate) {
            errMsg = "Please select return date";
          }
        }
      }

      if (errMsg) {
        enqueueSnackbar(`${errMsg}!`, {
          variant: "info",
          anchorOrigin: {
            vertical: isMobile ? "bottom" : "top",
            horizontal: isMobile ? "center" : "right",
          },
          autoHideDuration: 2000,
        });
      }

      return errMsg;
    },
    [isMobile, enqueueSnackbar]
  );

  return { checkSearchCondition };
};

export default useCheckSearchCondition;
